import { render, staticRenderFns } from "./CoreItemTwo.vue?vue&type=template&id=78d80824&scoped=true&"
import script from "./CoreItemTwo.vue?vue&type=script&lang=js&"
export * from "./CoreItemTwo.vue?vue&type=script&lang=js&"
import style0 from "./CoreItemTwo.vue?vue&type=style&index=0&id=78d80824&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d80824",
  null
  
)

export default component.exports